customElements.component = 'fabric-guide-redesign';

if (!customElements.get(customElements.component)) {
  class FabricGuideRedesign extends HTMLElement {
    constructor() {
      super();
      this.sliderEl = this.querySelector('.js-slider');

      console.log(this.sliderEl, "this.sliderEl")
    }

    initSlider() {
      this.sliderEl && new Swiper(this.sliderEl, {
        slidesPerView: 2,
        spaceBetween: 30,
        pagination: {
          el: this.querySelector('.swiper-pagination'),
          clickable: true,
        },
        navigation: {
          nextEl: this.querySelector('.swiper-button-next'),
          prevEl: this.querySelector('.swiper-button-prev'),
        },
        breakpoints: {
          768: {
            slidesPerView: 4,
            spaceBetween: 30,
          },
          1024: {
            slidesPerView: 8,
            spaceBetween: 28,
          },
        },
      });
    }

    connectedCallback() {
      this.initSlider();
    }
  }

  customElements.define(customElements.component, FabricGuideRedesign);
}